import {Component, inject, Input, input, output} from '@angular/core';
import {NgStyle} from '@angular/common';
import {ImagesService} from '../../../../services/general/images.service';

@Component({
  selector: 'app-product-analysis',
  imports: [NgStyle],
  templateUrl: './product-analysis.component.html',
  styleUrl: './product-analysis.component.scss'
})
export class ProductAnalysisComponent {

  _images = inject(ImagesService);

  title = input.required<string>();
  total = input.required<number | undefined>();
  today = input.required<string>();
  icon = input.required<string>();
  @Input() text: string = 'This month';
  @Input() accentColor: string = '#0D76BA';

  onClickEvent = output<void>();
  onClick() {
    this.onClickEvent.emit()
  }

}
